"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharePointAppId = void 0;
exports.SharePointAppId = "00000003-0000-0ff1-ce00-000000000000";
//# sourceMappingURL=constants.js.map